import moment from 'moment-timezone'
import React from 'react'

interface WrapperCustomMultiProps {
    v: any
    handleClose: (v: any) => void
    children: React.ReactNode
}

const WrapperCustomMulti = ({ v, handleClose, children }: WrapperCustomMultiProps) => {
    return (
        <div
            key={v.value}
            className='d-flex m-0 align-items-center rounded'
            style={{ background: '#e5e5e5', maxWidth: '300px' }}
        >
            <div
                className='border-start border-secondary px-2 text-black'
                style={{
                    display: '-webkit-box',
                    WebkitLineClamp: 2,
                    WebkitBoxOrient: 'vertical',
                    overflow: 'hidden',
                    maxWidth: '300px',
                    fontSize: '11px',
                }}
            >
                {children}
            </div>
            <div
                className='d-flex align-items-center cursor-pointer p-2 h-100'
                onClick={(e) => {
                    // console.log(v, 'v')
                    e.stopPropagation()
                    handleClose(v)
                }}
            >
                <i className='bi bi-x-lg align-middle' />
            </div>
        </div>
    )
}

export default WrapperCustomMulti